import LinkAnnotationPopupContainer from './LinkAnnotationPopupContainer';

export default LinkAnnotationPopupContainer;